import React, { Suspense, ComponentType } from 'react'

interface SuspenseWrapperIndexProps {
    Component: ComponentType<any>;
}

const SuspenseWrapperIndex: React.FC<SuspenseWrapperIndexProps> = ({ Component }) => {

    return (
        <Suspense fallback={<div className="opacity-0">Loading...</div>} >
            <Component /> 
        </Suspense>
    )
}

export default SuspenseWrapperIndex